<template>
  <div class="information" :class="{ hidden }">
    <a class="information-toggle" href="javascript:;" @click.prevent="onClickInformation">Information</a>
    <div v-if="showContent" class="information-content" v-html="page.text"></div>
  </div>
</template>

<script>
import EventBus from '../util/EventBus'

export default {
  name: 'information',
  components: {
  },
  data () {
    return {
      showContent: false,
      hidden: false
    }
  },
  created () {
    EventBus.$on('lightbox-mouseenter', this.onLightboxMouseEnter)
    EventBus.$on('lightbox-mouseleave', this.onLightboxMouseLeave)
  },
  destroyed () {
    EventBus.$off('lightbox-mouseenter', this.onLightboxMouseEnter)
    EventBus.$off('lightbox-mouseleave', this.onLightboxMouseLeave)
  },
  computed: {
    page () {
      return this.$store.getters.getPagesByType('Information')[0]
    },
    phone () {
      return this.$store.state.app.phone
    }
  },
  methods: {
    onClickInformation (event) {
      this.showContent = !this.showContent
    },
    onLightboxMouseEnter (event) {
      // NB: no captions on mobile
      if (this.phone) {
        return
      }

      this.hidden = true
    },
    onLightboxMouseLeave (event) {
      this.hidden = false
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';

.information {

  &.hidden {
    visibility: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// client/components/Information.vue